import React, { createContext, useEffect, useReducer, useContext, useRef } from "react";
import { LiferayService } from "../../../common/services/liferay/index";
import { ApplicationPropertiesContext } from "../../../common/context/ApplicationPropertiesProvider";
import { getSignedIdStatus } from "../../../common/utils/utilsFunc";

export const PaymentOnlineContext = createContext();
export const ACTIONS = {
  SET_IDCTACTO: "SET_IDCTACTO",
  SET_DETAIL_CLIENT:"SET_DETAIL_CLIENT",
  SET_ERROR:"SET_ERROR",
  SET_CURRENT_PAGE: "SET_CURRENT_PAGE",
  SET_WEB_CONTENT_TEXT: "SET_WEB_CONTENT_TEXT",
  SET_JSON_DEBT:"SET_JSON_DEBT",
  SET_RESPONSE_DEBT_C: "SET_RESPONSE_DEBT_C",
  SET_ENTITY_PAID: "SET_ENTITY_PAID",
  SET_ID_PAYMENT: "SET_ID_PAYMENT",
  SET_RESPONSE_PROOF_PAID: "SET_RESPONSE_PROOF_PAID",
  SET_WEB_CONTENT_TEXT_INFO: "SET_WEB_CONTENT_TEXT_INFO",
  SET_JSON_START_PAGO:"SET_JSON_START_PAGO",
  SET_RESPONSE_START_PAGO:"SET_RESPONSE_START_PAGO",
  SET_JSON_SEND_EMAIL: "SET_JSON_SEND_EMAIL",
  SET_RESPONSE_SEND_EMAIL: "SET_RESPONSE_SEND_EMAIL",
  SET_JSON_DOWNLOAD_COMPROV: "SET_JSON_DOWNLOAD_COMPROV",
  SET_RESPONSE_DOWNLOAD_COMPROV: "SET_RESPONSE_DOWNLOAD_COMPROV",
  
};

const initialState = {
  webContentText: "",
  errorFetch: null,
  idCtaCto: "",
  detailClient: null,
  currentPage: 0,
  jsonDebtCc: null,
  responseDebtCc: null,
  responseEntityPaid: null,
  idPayment: null,
  responseProofPaid: null,
  webContentTextInfo: "",
  jsonStartPago: null,
  responseStartPago: null,
  jsonSendEmail: null,
  responseSendEmail: null,
  jsonDownloadComp: null,
  responseDownloadComp: null,
};


const PaymentOnlineReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTIONS.SET_IDCTACTO: {
      return {
        ...state,
        idCtaCto: action.payload,
      };
    }
    case ACTIONS.SET_DETAIL_CLIENT: {
      return {
        ...state,
        detailClient: action.payload,
      };
    }
    case ACTIONS.SET_ERROR: {
      return {
          ...state,
          errorFetch: action.payload
      };
    }
    case ACTIONS.SET_CURRENT_PAGE: {
      return {
        ...state,
        currentPage: action.payload,
      };
    }
    case ACTIONS.SET_WEB_CONTENT_TEXT: {
      return {
        ...state,
        webContentText: action.payload,
      };
    }
    case ACTIONS.SET_JSON_DEBT: {
      return {
        ...state,
        jsonDebtCc: action.payload,
      };
    }
    case ACTIONS.SET_RESPONSE_DEBT_C: {
      return {
        ...state,
        responseDebtCc: action.payload,
      };
    }
    case ACTIONS.SET_ENTITY_PAID: {
      return {
        ...state,
        responseEntityPaid: action.payload,
      };
    }
    case ACTIONS.SET_ID_PAYMENT: {
      return {
        ...state,
        idPayment: action.payload,
      };
    }
    case ACTIONS.SET_RESPONSE_PROOF_PAID: {
      return {
        ...state,
        responseProofPaid: action.payload,
      };
    }
    case ACTIONS.SET_WEB_CONTENT_TEXT_INFO: {
      return {
        ...state,
        webContentTextInfo: action.payload,
      };
    }
    case ACTIONS.SET_JSON_START_PAGO: {
      return {
        ...state,
        jsonStartPago: action.payload,
      };
    }
    case ACTIONS.SET_RESPONSE_START_PAGO: {
      return {
        ...state,
        responseStartPago: action.payload,
      };
    }
    case ACTIONS.SET_JSON_SEND_EMAIL: {
      return {
        ...state,
        jsonSendEmail: action.payload,
      };
    }
    case ACTIONS.SET_RESPONSE_SEND_EMAIL: {
      return {
        ...state,
        responseSendEmail: action.payload,
      };
    }
    case ACTIONS.SET_JSON_DOWNLOAD_COMPROV: {
      return {
        ...state,
        jsonDownloadComp: action.payload,
      };
    }
    case ACTIONS.SET_RESPONSE_DOWNLOAD_COMPROV: {
      return {
        ...state,
        responseDownloadComp: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};
const PaymentOnlineContextProvider = ({ children }) => {
  const properties = useContext(ApplicationPropertiesContext);

  const [state, dispatch] = useReducer(PaymentOnlineReducer, initialState);
  const shouldClearCaptchaData = useRef(false)


  useEffect(() => {
    if(properties.name_web_content){
      LiferayService.getWebContent(properties.base_url_api,properties.name_web_content)
      .then((response) => {
        dispatch({
          payload: response,
          type: ACTIONS.SET_WEB_CONTENT_TEXT,
        });
        dispatch({
          payload: null,
          type: ACTIONS.SET_ERROR,
          });
      })
      .catch((error) => {
        dispatch({
        payload: error,
        type: ACTIONS.SET_ERROR,
        });
      })
    }
    if (properties.web_content_info_update_of_contact_information.trim()) {
      LiferayService.getWebContent(properties.base_url_api, properties.web_content_info_update_of_contact_information.trim())
        .then((response) => {
          dispatch({
            payload: response,
            type: ACTIONS.SET_WEB_CONTENT_TEXT_INFO,
          });
        })
      }
  },[]);

  React.useEffect(() => {
    if(state.idPayment){
      LiferayService.proofPayment(properties.base_url_api, state.idPayment, getSignedIdStatus())
      .then((response) => {
        dispatch({
          payload: response,
          type: ACTIONS.SET_RESPONSE_PROOF_PAID,
        });
        dispatch({
          payload: null,
          type: ACTIONS.SET_ERROR,
          });
      })
      .catch((error) => {
        dispatch({
        payload: error,
        type: ACTIONS.SET_ERROR,
        });
      })
    }
  }, [state.idPayment])

  React.useEffect(() => {
    if(state.jsonDebtCc){
      LiferayService.getPagoInfo(properties.base_url_api, state.jsonDebtCc, properties.codigo_empresa, properties.url_ws_empresa)
      .then((response) => {
        dispatch({
          payload: response,
          type: ACTIONS.SET_ENTITY_PAID,
        });

        if(response?.code === 0){
          LiferayService.getDebtCc(properties.base_url_api, state.jsonDebtCc, properties.url_ws_empresa)
          .then((response) => {
            dispatch({
              payload: response,
              type: ACTIONS.SET_RESPONSE_DEBT_C,
            });
            dispatch({
              payload: null,
              type: ACTIONS.SET_ERROR,
            });
          })
          .catch((error) => {
            dispatch({
            payload: error,
            type: ACTIONS.SET_ERROR,
            });
          })
        }

        if (response?.code === 1) {
          shouldClearCaptchaData.current = true
        }

        dispatch({
          payload: null,
          type: ACTIONS.SET_ERROR,
        });
      })
      .catch((error) => {
          dispatch({
          payload: error,
          type: ACTIONS.SET_ERROR,
          });
      })
    }
  }, [state.jsonDebtCc])

  React.useEffect(() => {
    if (state.idCtaCto) {
      LiferayService.consultarDetalleCuentaContrato(properties.base_url_api, state.idCtaCto, properties.url_ws_empresa, properties.codigo_empresa)
        .then((response) => {
          dispatch({
            payload: response,
            type: ACTIONS.SET_DETAIL_CLIENT,
          });
          dispatch({
            payload: null,
            type: ACTIONS.SET_ERROR,
          });
        })
        .catch((error) => {
          dispatch({
            payload: error,
            type: ACTIONS.SET_ERROR,
          });
          
          shouldClearCaptchaData.current = true
        })
    }
  }, [state.idCtaCto])

  React.useEffect(() => {
    if(state.jsonStartPago){
      LiferayService.startPago(properties.base_url_api, state.jsonStartPago, properties.codigo_empresa, getSignedIdStatus())
      .then((response) => {
        dispatch({
          payload: response,
          type: ACTIONS.SET_RESPONSE_START_PAGO,
        });
        dispatch({
          payload: null,
          type: ACTIONS.SET_ERROR,
          });
      })
      .catch((error) => {
        dispatch({
        payload: error,
        type: ACTIONS.SET_ERROR,
        });
      })
    }

  }, [state.jsonStartPago])

  React.useEffect(() => {
    if(state.jsonSendEmail){
      LiferayService.sendEmaillComprobante(properties.base_url_api,state.jsonSendEmail)
      .then((response) => {
        dispatch({
          payload: response,
          type: ACTIONS.SET_RESPONSE_SEND_EMAIL,
        });
        dispatch({
          payload: null,
          type: ACTIONS.SET_ERROR,
        });
        dispatch({
          payload: null,
          type: ACTIONS.SET_JSON_SEND_EMAIL,
        });
      })
      .catch((error) => {
        dispatch({
        payload: error,
        type: ACTIONS.SET_ERROR,
        });
      })
    }

  }, [state.jsonSendEmail])

  React.useEffect(() => {
    if(state.jsonDownloadComp){
      LiferayService.getHtmlComprobante(properties.base_url_api, state.jsonDownloadComp)
      .then((response) => {
        dispatch({
          payload: response,
          type: ACTIONS.SET_RESPONSE_DOWNLOAD_COMPROV,
        });
        dispatch({
          payload: null,
          type: ACTIONS.SET_ERROR,
        });
        dispatch({
          payload: null,
          type: ACTIONS.SET_JSON_DOWNLOAD_COMPROV,
        });
      })
      .catch((error) => {
        dispatch({
        payload: error,
        type: ACTIONS.SET_ERROR,
        });
      })
    }

  }, [state.jsonDownloadComp])

  return (
    <PaymentOnlineContext.Provider value={[state, dispatch, shouldClearCaptchaData]}>
      {children}
    </PaymentOnlineContext.Provider>
  );
};
export default PaymentOnlineContextProvider;